import { IContentSource } from "../../../domain/drawing";

export class CsvSource implements IContentSource {
  constructor(private _getToken: () => string, private filePath: string) {
  }

  get token(): string {
    return this._getToken();
  }

  get source(): string {
    return "/api/documents/ext/csv-download?token=" + this.token + "&filePath=" + encodeURIComponent(this.filePath);
  }

  clone(): CsvSource {
    return new CsvSource(this._getToken, this.filePath);
  }
}
